<template>
<div class="xes-question-filter" ref="questionFilter">
  <!-- 知识树 -->
  <keep-alive>
    <tree 
      :secret="secret" 
      :action="actions.getCategorytree" 
      :department="formdata.department"
      :subjectId="formdata.subject_id"
      :filterhide="filterhide"  
      :treeData="filterList.knowledges" 
      v-if="leftTree" 
      :class="{treefixed:!treeview}" 
      :is_and_set="0"
      @tree-change="treeChange"
      ref="tree" 
      @status-error="statusError" 
      @ajax-error="ajaxError">
    </tree>
  </keep-alive>
  <!-- 右侧部分 -->
  <div class="question-main" ref="questionMain">
    <!-- 筛选项 -->
    <filters
      ref="filter"
      :formdata="formdata"
      :filterlist="filterList"
      :treeview="treeview"
      :filterhide="filterhide"
      :actions="actions"
      :resizeEl="resizeEl"
      @treeshow="treeClose"
      @get-test-list="getTestList"
      @page-all="pageAll"
      @get-filter="getFilterInfos"
      :secret="secret"
      @status-error="statusError"
      @ajax-error="ajaxError"
      :testList="testList"
    >
      <template slot="filterSort" slot-scope="{list}">
        <slot name="filterSort" :list="list"></slot>
      </template>
    </filters>
    <!-- 试题列表 -->
    <xes-question-single
      v-for="(item,index) in testList"
      :key="''+item.id+index"
      :data="item"
      :index="(formdata.page_num-1)*formdata.size+index"
      :activelist="activelist"
      ref="questions"
      :options="question_options"
      :mode="question_mode"
      :expand="question_expand"
      :operatingfloat="question_operatingfloat"
      :move="question_move"
      @drag-start="(data,index)=>$emit('drag-start',data,index)"
      @drag-end="(data,index)=>$emit('drag-end',data,index)"
      @drag-click="(data,index)=>$emit('drag-click',data,index)"
    >
      <template slot="topButtons" slot-scope="{data,index,fade}">
        <el-button @click="materialTopic(data,index,fade)" title="材料全选"><i class="iconfont icon-tianjiashiti"></i>材料全选</el-button>
        <slot name="topButtons" :data="data" :index="index" :fade="fade"></slot>
      </template>
      <template slot="bottomButtons" slot-scope="{data,index,fade}">
        <el-button v-if="matchActiveList(data.id)" class="btn" @click="delTopic(data,index,fade)"><i class="iconfont icon-yichu"></i>移除</el-button>
        <el-button v-else class="btn" @click="addTopic(data,index,fade)"><i class="iconfont icon-tianjiashiti"></i>选题</el-button>
        <slot name="bottomButtons" :data="data" :index="index" :fade="fade"></slot>
      </template>
      <template slot="topInfo" slot-scope="{data,index}">
        <slot name="topInfo" :data="data" :index="index"></slot>
      </template>
      <template slot="bottomInfo" slot-scope="{data,index}">
        <slot name="bottomInfo" :data="data" :index="index"></slot>
      </template>
      <template slot="middleInfo" slot-scope="{data,index}">
        <slot name="middleInfo" :data="data" :index="index"></slot>
      </template>
    </xes-question-single>
    <div class="nodata" v-if="testList.length == 0">
      <div class="nodatapic"></div>
      <!-- <img :src="nodatapic" /> -->
      <p>您的查询结果无内容</p>
    </div>
    <div class="bottom-box"></div>
  </div>
  <!-- 底部页码 -->
  <div class="question-filter-page">
    <el-pagination
      @current-change="pageChange"
      :current-page.sync="formdata.page_num"
      :page-size="formdata.size"
      layout="total, prev, pager, next, jumper"
      :total="page_total > 1000 ? 1000 : page_total">
    </el-pagination>
  </div>
</div>
</template>

<script>
import filters from './filter'
import tree from 'xes-frontend-ui/packages/question-tree'
import { httpRequest } from 'xes-frontend-ui/src/utils/ajax'
export default {
  name: 'xes-question-filter',
  props: {
    token: {
      type: String
    },
    treeview: {
      type: Boolean,
      default: false
    },
    filterhide: {
      type: Array,
      default: function () {
        return []
      }
    },
    departmentid: {
      required: true
    },
    subjectid: {
      required: true
    },
    activelist: {
      type: Array,
      default: function () {
        return []
      }
    },
    question_options: {
      type: Object,
      default: function () {
        return {}
      }
    },
    question_mode: {
      type: String,
      default: 'common'
    },
    question_expand: {
      type: Boolean,
      default: true
    },
    question_operatingfloat: {
      type: Boolean,
      default: false
    },
    question_move: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    },
    resizeEl: {
      default:'#filters'
    }
  },
  data () {
    return {
      page_total: 0,
      formdata: {
        subject_id: this.subjectid, // 学科id
        department: this.departmentid,
        grade_ids: '',
        type_id: '',
        category_id: '',
        cate_tree_id: '',
        difficulty_type: '',
        year_id: '',
        province_id: '',
        city_id: '',
        country_id: '',
        source_type_id: '',
        source_seq_id: '',
        knowledge_ids: '',
        level_id: '',
        school_id: '',
        search_mode: 0,
        search_text: '',
        sort_type: '',
        is_asc_sort: '',
        is_and_set: 0,
        size: 10,
        page_num: 1,
        alltotal: 0, // 总条数
        is_verify: ''// 是否审核
      },
      filterList: {
        categorys: [],
        levels: [],
        grades: [],
        knowledges: [],
        provinces: [],
        source_types: [],
        types: [],
        years: [],
        page_list: [10, 20, 30],
        department: Number,
        subject_id: Number,
        subjects: [],
        is_verifys: [],
        dsoptions: []
      },
      testList: [],
      treeshow: this.treeview, // 知识树是否显示
      loading: null,
      secret: ''
    }
  },
  components: {
    filters,
    tree
  },
  computed: {
    leftTree () {
      return this.treeshow && (!this.filterhide.includes('knowledge') || !this.filterhide.includes('cate_tree'))
    }
  },
  methods: {
    treeClose(type){
      if(typeof type == 'undefined'){
        this.treeshow = !this.treeshow
      }else{
        this.treeshow = type
      }
    },
    throwError (action) {
      // 若无相关地址，抛出错误
      if (!this.actions[action]) {
        throw new Error(`${action}地址为空！`)
      }
      return true
    },
    pageAll () {
      let list = []
      let fns = []
      Array.isArray(this.$refs.questions) && this.$refs.questions.forEach((one, i) => {
        let t = one.$refs.single
        let arr = []
        arr = this.activelist.filter(el => {
          if (one.$refs.single.testData.id == el) {
            return el
          }
        })
        if (!arr.length) {
          list.push(one.data)
          fns.push(() => {
            this.addTopic(one.data, [one.index], t.shadowMove)
          })
        }
      })

      this.$emit('page-all', list, (mode) => {
        fns.forEach(el => {
          el()
        })
      })
    },
    toFade(id,mode){
        Array.isArray(this.$refs.questions) && this.$refs.questions.forEach((one, i) => {
            if(!Array.isArray(id)){
              id = [id]
            }
            if(id.includes(Number(one.testData.id))||id.includes(String(one.testData.id))){
                one.$refs.single.shadowMove(mode || 'leave-right')
            }
        })
    },
    getSecret () { // 获取secret
      const isActionNotPass = this.throwError('getSecret')
      if (!isActionNotPass) return
      var option = {
        method: 'POST',
        params: {uuid: this.getCookie('X-Request-Id')},
        action: this.actions.getSecret
      }
      httpRequest(option).then(res => {
        if (res.status == 100) {
          this.secret = res.data
          this.getFilterInfos()
        } else {
          this.statusError(res)
        }
      }).catch(err => {
        this.ajaxError(err)
      })
    },
    getCookie (name) {
      if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(name + '=')
        if (start != -1) {
          start = start + name.length + 1
          var end = document.cookie.indexOf(';', start)
          if (end == -1) {
            end = document.cookie.length
          }
          return unescape(document.cookie.substring(start, end))
        }
      }
      return ''
    },
    getFilterInfo () { // 获取筛选项信息
      setTimeout(() => {
        this.formdata.department = this.departmentid
        this.formdata.subject_id = this.subjectid
        this.getFilterInfos()
      })
    },
    getFilterInfos () {
      const isActionNotPass = this.throwError('showSearch')
      if (!isActionNotPass || this.loading) return
      this.clearData()

      var option = {
        method: 'POST',
        params: {department: this.formdata.department, subject_id: this.formdata.subject_id, secret: this.secret},
        action: this.actions.showSearch
      }
      this.loading = this.$loading({
        background: 'rgba(255, 255, 255, 0.5)',
        target: this.$refs.questionFilter
      })
      httpRequest(option).then(res => {
        this.loading.close()
        this.loading = null
        if (res.status == 100) {
          this.filterList.types = res.data.types
          this.filterList.categorys = res.data.categorys
          this.filterList.subjects = res.data.department_subjects
          this.filterList.is_verifys = res.data.is_verify
          this.filterList.knowledges = res.data.knowledge_json
          this.filterList.dsoptions = res.data.departments.map((item, index) => {
            item.label = item.value
            item.value = item.id
            item.children = res.data.department_subjects[item.id].map(key => {
              key.label = key.value
              key.value = key.id
              return key
            })
            return item
          })
          this.filterList.provinces = res.data.provinces.map(el => {
            el.children = []
            return el
          })
          this.filterList.years = res.data.years
          this.filterList.source_types = res.data.source_types.map(el => {
            el.children = []
            return el
          })
          this.filterList.levels = res.data.ability_levels.list
          this.filterList.grades = res.data.department_grades
          this.getTestList()
          // this.$nextTick(()=>{
          //   this.$refs.tree.setTreeType(1)
          // })
        } else {
          this.statusError(res)
        }
      }).catch(err => {
        this.ajaxError(err)
      })
    },
    pageChange (val) { // 页码改变
      this.formdata.page_num = val
      this.$refs.questionMain.scrollTop = 0
      this.getTestList()
    },
    // 知识树筛选改变
    treeChange (treeParams) {
      this.formdata = Object.assign({}, this.formdata, treeParams, {
        page_num: 1
      })
      this.getTestList()
    },
    getTestList () { // 获取试题列表
      const isActionNotPass = this.throwError('search')
      if (!isActionNotPass || this.loading) return
      if (this.formdata.type_id == '') {
        this.formdata.category_id = ''
      }
      this.loading = this.$loading({
        background: 'rgba(255, 255, 255, 0.5)',
        target: this.$refs.questionFilter
      })
      let option = {
        method: 'POST',
        params: {...this.formdata, secret: this.secret},
        action: this.actions.search
      }
      httpRequest(option).then(res => {
        this.loading.close()
        this.loading = null
        if (res.status == 100) {
          this.testList = res.data.question_list
          this.page_total = res.data.total
          this.formdata.alltotal = res.data.total
        } else {
          this.statusError(res)
        }
      })
        .catch(err => {
          this.ajaxError(err)
        })
    },
    clearData () { // 清空筛选项
      this.formdata.grade_ids = ''
      this.formdata.type_id = ''
      this.formdata.category_id = '0'
      this.formdata.cate_tree_id = ''
      this.formdata.difficulty_type = ''
      this.formdata.level_id = ''
      this.formdata.year_id = ''
      this.formdata.province_id = ''
      this.formdata.city_id = ''
      this.formdata.country_id = ''
      this.formdata.school_id = ''
      this.formdata.source_type_id = ''
      this.formdata.source_seq_id = ''
      this.formdata.knowledge_ids = ''
      this.formdata.search_mode = 0
      this.formdata.search_text = ''
      this.formdata.sort_type = ''
      this.formdata.is_asc_sort = ''
      this.formdata.is_and_set = 0
      this.formdata.size = 10
      this.formdata.page_num = 1
      this.formdata.is_verify = ''
      this.$refs.tree && this.$refs.tree.clearData()
      this.$refs.filter.clearData()
    },
    addTopic (data, index, fade) {
      this.$emit('add-topic', data, index, (mode) => {
        if (data.id) {
          if (!this.matchActiveList(data.id)) {
            this.activelist.push(data.id)
            fade(mode || 'leave-right')
          }
        } else if (data.question_list) {
          data.question_list.forEach(el => {
            if (!this.matchActiveList(el.id)) {
              this.activelist.push(el.id)
              fade(mode || 'leave-right')
            }
          })
        }
      })
    },
    delTopic (data, index, fade) {
      this.$emit('del-topic', data, index, (mode) => {
        if (data.id) {
          let index = this.activelist.indexOf(data.id)
          if (index > -1) {
            this.activelist.splice(index, 1)
          }
        }
        fade(mode || 'enter-right')
      })
    },
    materialTopic (data, index, fade) {
      let option = {
        method: 'POST',
        params: {material_id: Number(data.material_id), secret: this.secret},
        action: this.actions.getMaterial
      }
      httpRequest(option).then(res => {
        this.$emit('material-topic', res.data.question_ids, index, (mode) => {
          let ids = res.data.question_ids
          for (let i = 0; i < ids.length; i++) {
            if (!this.matchActiveList(ids[i])) {
              this.activelist.push(ids[i])
              fade(mode || 'leave-right')
            }
          }
        })
      })
    },
    matchActiveList (id) {
      let state = false
      this.activelist.forEach(el => {
        if (el == id) {
          state = true
        }
      })
      return state
    },
    statusError (data) {
      console.log(data)
      this.$emit('status-error', data)
    },
    ajaxError (data) {
      console.log(data)
      this.$emit('ajax-error', data)
    }
  },
  mounted () {
    this.getSecret()
    // this.getFilterInfo()
  }
}
</script>



// WEBPACK FOOTER //
// packages/question-filter/src/index.vue